import { render } from "./JobDetailsSection.vue?vue&type=template&id=5ae3e9ea&scoped=true"
import script from "./JobDetailsSection.vue?vue&type=script&lang=js"
export * from "./JobDetailsSection.vue?vue&type=script&lang=js"

import "./JobDetailsSection.vue?vue&type=style&index=0&id=5ae3e9ea&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae3e9ea"]])

export default __exports__